import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import app from "./modules/app";
import user from "./modules/user";
import student from "./modules/student"
import branch from "@/store/modules/branch";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    user,
    student,
    branch
  },
  getters
});

export default store;
